<div *ngIf="showSpinner | async" class="overlay">
  <div class="center_spinner">
    <mat-progress-spinner
      color="warn"
      mode="indeterminate"
      diameter="60"
    ></mat-progress-spinner>
  </div>
</div>
